var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"share"},[_c('ui-button',{staticClass:"btn--share",attrs:{"icon":"share","iconPosition":"top","size":"s","text":""}},[_vm._v("\n    Partager\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }